var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestsForNormalityOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.6919,
    cy: 17.6908,
    r: 10.3116,
    transform: "rotate(165 52.6919 17.6908)",
    stroke: "#272d55",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6919,
    cy: 46.6908,
    r: 10.3116,
    transform: "rotate(165 20.6919 46.6908)",
    stroke: "#272d55",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.0815,
    cy: 72.0791,
    r: 13.1298,
    transform: "rotate(165 78.0815 72.0791)",
    fill: "#272d55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4512 86.4102L89.6614 18.2",
    stroke: "#272d55",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestsForNormalityOperationIcon);
export default __webpack_public_path__ + "static/media/TestsForNormalityOperationIcon.949e82d3e0ea9f1c7d09b4944529d2b1.svg";
export { ForwardRef as ReactComponent };